import React from 'react';
import { TopBar } from '../components/TopBar';
import { Navbar } from '../components/Navbar';
import { useScreenInit } from '../useScreenInit';
import { motion } from 'framer-motion';
export function ShopProducts() {
  useScreenInit();
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.8
  }} className="min-h-screen bg-white font-sans selection:bg-[#b22222] selection:text-white" data-id="element-575">
      <TopBar data-id="element-576" />
      <Navbar data-id="element-577" />
      <main className="py-20" data-id="element-578">
        <div className="mx-[4.1rem]" data-id="element-579">
          <div className="max-w-[1440px] mx-auto px-6" data-id="element-580">
            <h1 className="font-serif text-5xl mb-8" data-id="element-581">Shop Products</h1>
            <p className="text-gray-600 text-lg" data-id="element-582">
              Browse our collection of products available for purchase.
            </p>
          </div>
        </div>
      </main>
    </motion.div>;
}